import { PermissionsType } from '@/common/permissionsConst';
import { Themes } from '@maxtropy/components';
import PhotovoltaicMonitoringCenter from '.';

const routes = [
  {
    path: '/pv/monitoring/center',
    permission: PermissionsType.P_PV_MONITORING_CENTER,
    element: <PhotovoltaicMonitoringCenter />,
  },
];

export default routes;
